import { MdEmail } from "react-icons/md";
import { FaYoutube, FaWhatsapp } from "react-icons/fa6";
import { useContext } from "react";
import { BsLinkedin } from "react-icons/bs";

import themeContext from "../../themeContext/themeContext";

import {
  FooterContainer,
  Email,
  FooterSocials,
  CopyRight,
} from "./styledComponents";

function Footer() {
  const { isDarkMode } = useContext(themeContext);

  return (
    <FooterContainer isDarkMode={isDarkMode} id="contact">
      <Email>
        <MdEmail
          style={{
            fontSize: "1.1rem",
            fontWeight: "bolder",
            marginRight: "5px",
          }}
        />
        <a href="mailto: tejababu08@gmail.com">tejababu08@gmail.com</a>
      </Email>
      <FooterSocials>
        <a
          aria-label="youtube"
          href="https://www.youtube.com/@achieversclubofficial7201"
          target="_blank"
          rel="noopener noreferrer"
        >
          <FaYoutube
            color="#FF0000"
            style={{
              fontSize: "45px",
              transition: "all 0.3s ease-in-out",
              padding: "8px",
            }}
          />
        </a>

        <a
          aria-label="linkedin"
          href="https://www.linkedin.com/company/achievers-club-digital-marketing/"
          target="_blank"
          rel="noopener noreferrer"
        >
          <BsLinkedin
            color="#0366c3"
            style={{
              fontSize: "45px",
              transition: "all 0.3s ease-in-out",
              padding: "8px",
            }}
          />
        </a>

        <a
          aria-label="whatsapp"
          href="https://wa.me/916304390656?text=Hey,%20i%20can%20pay%20199%20and%20want%20to%20join%20the%20Boot%20Camp."
          target="_blank"
          rel="noopener noreferrer"
        >
          <FaWhatsapp
            color="#25D366"
            style={{
              fontSize: "45px",
              transition: "all 0.3s ease-in-out",
              padding: "8px",
            }}
          />
        </a>
      </FooterSocials>
      <CopyRight>
        Copyright 2024 © Achievers Club - All Right Reserved.
      </CopyRight>
    </FooterContainer>
  );
}

export default Footer;
